import { render, staticRenderFns } from "./TeacherRow.vue?vue&type=template&id=d12f8f4e&"
import script from "./TeacherRow.vue?vue&type=script&lang=js&"
export * from "./TeacherRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports